import { ref } from 'vue';

export default function useResource(props, resource) {
  const adjustments = ref(
    props.adjustments !== 'undefined' && props.adjustments ? props.adjustments : resource.meta.adjustments
  );
  const attributes = ref(resource.meta.attributes);
  const config = ref(typeof props.config !== 'undefined' ? props.config : resource.meta.config);
  const meta = ref(typeof props.meta !== 'undefined' ? props.meta : resource.meta);
  const resourceType = ref(
    props.resourceType !== 'undefined' && props.resourceType ? props.resourceType : resource.meta.resourceType
  );
  const getElement = (attribute, category, meta = null) => {
    if (!meta) {
      meta = resource.meta;
    }

    return meta.elements[attribute][category] ?? null;
  };

  return {
    adjustments,
    attributes,
    config,
    getElement,
    meta,
    resourceType,
  };
}
